import { IFreeInputBehavior } from "./IFreeInputBehavior";

export interface IFreeInputBehaviorSpecifiable {
  freeInputBehavior: IFreeInputBehavior;
}

export function instanceOfIFreeInputBehaviorSpecifiable(instance: any): instance is IFreeInputBehaviorSpecifiable {
  return instance
    && (instance.freeInputBehavior !== undefined);
}
